import {
  whiteShades,
  primaryColors,
} from "../../assets/styles/helpers/colors.styles";

export const progressBarStyle = {
  "&.MuiLinearProgress-root.MuiLinearProgress-colorPrimary": {
    backgroundColor: whiteShades.shade1,
  },
  ".MuiLinearProgress-bar": {
    backgroundColor: primaryColors.orange,
  },
};
